module.exports = __webpack_public_path__ + "media/images/bg-light-wood-154150076e416c5e145990438075de43.jpg";